import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface UsersCapacityHoursPayload extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_USERS_CAPACITY_HOURS;
    id: string;
    attributes: {
      aggregate: {
        total_capacity_hours: InsightMetric;
      };
    };
  };
}

export const parseUsersCapacityHoursPayload = (
  payload: BaseInsightPayload
): UsersCapacityHoursPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_USERS_CAPACITY_HOURS,
    data.attributes,
    false,
    true
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: {
      total_capacity_hours: InsightMetric;
    };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_USERS_CAPACITY_HOURS,
      id: data.id,
      attributes: {
        aggregate: {
          total_capacity_hours: typedAttributes.aggregate.total_capacity_hours,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
